/* eslint-disable max-len */
import { colorAccent, colorFieldsBorder, colorText } from '@/utils/palette';
import React from 'react';
import styled from 'styled-components';

const TextAreaField = ({ name, label, value, placeholder, error, defaultValue, onChange, helperText, ...props }) => {
  return (
    <div>
      {label && <Label error={error}>{label}</Label>}
      <TextArea
        name={name}
        value={value}
        defaultValue={defaultValue || props?.input?.value}
        placeholder={placeholder || 'Enter the text here...'}
        error={error}
        onChange={onChange}
      />
      {helperText && <HelperText>{helperText}</HelperText>}
      {error && <ErrorMessage>{error}</ErrorMessage>}
    </div>
  );
};

export default TextAreaField;

const HelperText = styled.div`
  font-size: 12px;
  margin-top: 5px;
  color: ${colorText};
`;

const Label = styled.div`
  font-size: 12px;
  margin-top: 5px;
  color: ${(props) => (props.error ? 'red' : colorText)};
`;

const ErrorMessage = styled.div`
  color: red;
  margin-top: -5px;
  margin-bottom: 20px;
  font-size: 12px;
`;

const TextArea = styled.textarea`
  width: 100%;
  border: 1px solid ${(props) => (props?.error ? 'red' : colorFieldsBorder)}; /* Change border to red if error exists */
  border-radius: 5px;
  outline: none;
  padding: 10px;
  white-space: pre-wrap;
  transition:
    border-color 0.2s ease-in-out,
    box-shadow 0.2s ease-in-out;

  &:focus {
    outline: none !important;
    border: 1px solid ${(props) => (props?.error ? 'red' : colorAccent)}; /* Change border to red or accent on focus */
  }
  background-color: transparent !important;
  color: ${colorText};
`;
